// import SampleRoutes from './routes'
import 'windi.css'
import ResourceRoutes from './routes'

export default {
  // name version 必须为字面常量
  name: 'legacy-resource',
  title: '数据中台',
  version: '5.0.0.7',
  description: 'resource',
  routes: ResourceRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'ApplyApplicationApi',
      'OpenApiApi',
      'OpenApiCallRecordApi',
      'DbConnectionStringApi',
      'OpenApiDataMappingApi',
      'ModelApi',
    ],
  },
  config: {
    currentEnv: {
      VUE_APP_STANDARD_SERVER: 'http://resource-c2.wiz.top:8000',
      VUE_APP_CURRENT_PROJECT: 'RESOURCE',
      VUE_APP_UPLOAD_SERVER: 'https://std-taskserver-bs.dev.wiz.top',
      VUE_APP_DATASEASE_PAGE: 'https://visualization-ui-resource.dev.wiz.top',
      VUE_APP_KETTLE_PAGE: 'http://devjre01.wiz.top:8480',
      VUE_APP_RUN_PAGE: 'http://devdataease01.wiz.top:8100/#/de-link/bJhtpoCD',
      VUE_APP_DIY_SERVER: 'http://pr.code.wiz.top:1052',
      VUE_APP_DIY_TABLE_ID: '9b4f95be-8a22-41b3-9cf7-1f7a94fe2127',
      VUE_APP_DIY_AVATAR_PATH: 'http://devcode06.wiz.top:9010/zhengning2-public',
      VUE_APP_FILE_PREVIEW_SERVER: 'http://devvueui01.wiz.top:9990',
      VUE_APP_PORTAL_SERVER: 'http://resource-c2.wiz.top:7900',
      environment: 'DIY',
    },
  },
  // loadcss: true,
  // 异步初始化函数原型
  // init: async (store, router, config) => {
  // },
}
